// Canonical sales channels — used by the Watch form, the template builder,
// and the Dashboard "currently for sale" panel.
export const LISTING_CHANNELS = [
  "eBay",
  "Etsy",
  "Chrono24",
  "Instagram",
  "Facebook Marketplace",
  "Private Sale",
  "Local Dealer",
  "Multi-channel",
];

/**
 * Days since `isoDate`, or null if the date is missing / unparseable.
 */
export function listingAgeDays(isoDate) {
  if (!isoDate) return null;
  const t = Date.parse(isoDate);
  if (Number.isNaN(t)) return null;
  const days = Math.floor((Date.now() - t) / 86_400_000);
  return Math.max(0, days);
}

/**
 * "Just listed", "7 days on sale", "3 weeks on sale", "2 months on sale".
 */
export function listingAgeLabel(isoDate) {
  const d = listingAgeDays(isoDate);
  if (d === null) return null;
  if (d === 0) return "Listed today";
  if (d === 1) return "1 day on sale";
  if (d < 14) return `${d} days on sale`;
  if (d < 60) return `${Math.floor(d / 7)} weeks on sale`;
  return `${Math.floor(d / 30)} months on sale`;
}

/**
 * Stale threshold — configurable if you prefer a shorter ceiling.
 * Listings older than 60 days get a rose-coloured "stale" badge.
 */
export function isStaleListing(isoDate, thresholdDays = 60) {
  const d = listingAgeDays(isoDate);
  return d !== null && d >= thresholdDays;
}
